import { KEYS } from './keys'
import { useAppStore } from '@/state'
import type { Handler } from './types'
import { amplitude } from '@/lib/amplitude'
import { COMMIT_INFO_BRANCH, FRONTEND_REVISION } from '@/constants'

const getGlobals = () => ({
  branch: COMMIT_INFO_BRANCH,
  revision: FRONTEND_REVISION,
  sessionID: useAppStore.getState().sessionID,
})

export const amplitudeHandler: Handler = {
  name: 'amplitude',
  environments: ['prod', 'stage'],
  handle(key: string, data: any): void {
    switch (key) {
      case KEYS.MODEL_LOADED:
        amplitude.track('Model Loaded', { ...getGlobals(), ...data })
        break

      case KEYS.MEMORY:
        amplitude.track('Memory Snapshot', { ...getGlobals(), ...data })
        break

      case KEYS.VIEW_BATCH:
        amplitude.track('View Batch', { ...getGlobals(), ...data })
        break

      default:
        amplitude.track(key, data)
    }
  },
}

export const testHandler: Handler = {
  name: 'test',
  environments: ['test', 'dev'],
  handle(key: string, data: any): void {
    if (!window.Cypress) return
    if (!window.arcus) window.arcus = []

    window.arcus.push({ key, data: { ...getGlobals(), ...data } })

    try {
      console.log('arcus: ', key, JSON.stringify(data))
    } catch (error) {
      console.debug('Test handler failed:', error)
    }
  },
}
